export default __webpack_public_path__ + "images/pages/quiz/categories/desktop_other-f3947291a7bebe5d7b3c89a78f079755.svg";